import { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useScreenshot, createFileName } from '../../../../hooks/useScreenShot';
import { useClickmap } from '../../../../hooks/useClickmap';
import { Button } from '@material-ui/core';
import { BodyBold } from '../../primitive/TypographyUI';
import { List, ScreenshotContainer, FitImage, CoverContainer, ErrorCover, Skeleton } from './SharedStyled';

type Props = {
  org_id: string;
  project_id: string;
  round_id: string;
  variation_id: string;
  segment: any;
  src: string;
  hide?: boolean;
  isGreenMode?: boolean;
  dataLimit?: number;
};

const Clickmap: FC<Props> = ({
  org_id,
  project_id,
  round_id,
  variation_id,
  segment,
  src,
  hide = false,
  isGreenMode,
  dataLimit,
}) => {
  const { containerRef, error, loading } = useClickmap(
    org_id,
    project_id,
    round_id,
    variation_id,
    segment,
    isGreenMode,
    dataLimit,
  );
  const [image, takeScreenShot] = useScreenshot({ type: 'image/jpeg', quality: 1.0 });
  const download = (image: string | void, { extension = 'jpg' } = {}) => {
    if (!image) return;
    const a = document.createElement('a');
    a.href = image;
    a.download = createFileName(extension, `clickmap_variation:${variation_id}_${segment}`);
    a.click();
  };
  const downloadScreenshot = (ref: any) => {
    takeScreenShot(ref.current, {
      allowTaint: false,
      useCORS: true,
    }).then(download);
  };

  const Screenshot = useMemo(
    () => (
      <ScreenshotContainer
        className={`clickmap_container${hide ? ' hidden' : ''}`}
        id={`clickmap_${variation_id}`}
        ref={containerRef}
      >
        <FitImage src={src} alt={`clickmap-screenshot-${variation_id}`} />
        <CoverContainer>
          {loading && <Skeleton />}
          {error && <ErrorCover> Error... :( </ErrorCover>}
        </CoverContainer>
      </ScreenshotContainer>
    ),
    [hide, variation_id, src, containerRef, error, loading],
  );

  return (
    <List>
      <style>{canvasStyle}</style>
      <BodyBold>
        <Link to={`../experiments/${project_id}/variations/${variation_id}?tab=overview&org=${org_id}`}>
          {variation_id}
        </Link>
      </BodyBold>
      {Screenshot}
      <Button size="small" color="primary" variant="contained" onClick={() => downloadScreenshot(containerRef)}>
        Download screenshot
      </Button>
      {image && <div>screenshop taken</div>}
    </List>
  );
};

const canvasStyle = `
.hidden canvas {display: none;}
.clickmap_container canvas {width: 100%; height: 100%;}
`;

export default Clickmap;
